export default "__VITE_ASSET__jW2rYGEy__"